// @ts-strict-ignore
import { ChecklistItemTemplate } from '@/types';
import {
    UPDATE_ORG_CHECKLIST_ITEM_TEMPLATES,
    TryUpdateOrgChecklistItemTemplates,
} from '@/actions/orgChecklistItemTemplates';

export function orgChecklistItemTemplates(
    state: ChecklistItemTemplate[] = [],
    action: TryUpdateOrgChecklistItemTemplates,
): ChecklistItemTemplate[] {
    switch (action.type) {
        case UPDATE_ORG_CHECKLIST_ITEM_TEMPLATES: {
            return action.payload;
        }

        default:
            return state;
    }
}
